var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#C2CFE0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1593 2.00513C13.4232 2.08608 14.4231 3.12337 14.4231 4.39158V4.48173C17.0933 5.46543 18.9231 7.99949 18.9231 10.8887L18.9203 17.6H20.5C20.9142 17.6 21.25 17.9358 21.25 18.35C21.25 18.7643 20.9142 19.1 20.5 19.1H16.5C16.4678 19.1 16.436 19.098 16.4048 19.0941H15.1107C15.0259 20.6222 13.8121 21.8534 12.2791 21.9879L12 22C10.4431 21.9499 9.17449 20.7734 9.00408 19.269L8.98934 19.0941H7.59517C7.56401 19.098 7.53224 19.1 7.5 19.1H3.5C3.08579 19.1 2.75 18.7643 2.75 18.35C2.75 17.9358 3.08579 17.6 3.5 17.6H5.1791L5.17692 10.8887C5.17692 8.08704 6.89749 5.61933 9.43652 4.5754L9.67692 4.48173V4.39158C9.67692 3.12337 10.6768 2.08608 11.9407 2.00513H12.1593ZM12.0366 3.50206C11.5511 3.53315 11.1769 3.92573 11.1769 4.39158V5.50714L10.0069 5.96271C7.99849 6.78849 6.67692 8.72901 6.67692 10.8887V17.5941H17.4231V10.8887C17.4231 8.65753 16.0132 6.66609 13.9046 5.88926L12.9231 5.52769V4.39158C12.9231 3.96582 12.6105 3.60128 12.1861 3.51794L12.0778 3.50309L12.0366 3.50206Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.b2cb684e.svg";
export { ForwardRef as ReactComponent };